<template>
    <div>

        <!-- Table -->

        <trax-ui-card-plain-header-with-actions :title="lang.polaris.common.hdv_flows" :actions="card_actions" :bus="bus">
            <enac-custom-hdv-crud-table :bus="bus"></enac-custom-hdv-crud-table>
        </trax-ui-card-plain-header-with-actions>

        <!-- Delete confirm modal -->

        <trax-ui-modal-confirm id="enac-custom-hdv-delete" :title="lang.polaris.settings.flow_deletion" :bus="bus">
            {{ lang.polaris.settings.confirm_delete_flow_q }}
        </trax-ui-modal-confirm>

        <!-- Delete all confirm modal -->

        <trax-ui-modal-confirm id="enac-custom-hdv-delete-all" :title="lang.polaris.settings.flows_deletion" :bus="bus">
            {{ lang.polaris.settings.confirm_delete_flows_q }}
        </trax-ui-modal-confirm>

        <!-- Check all confirm modal -->

        <trax-ui-modal-confirm id="enac-custom-hdv-check-all" :title="lang.polaris.settings.flows_check" :bus="bus">
            {{ lang.polaris.settings.confirm_check_flows_q }}
        </trax-ui-modal-confirm>
    
        <!-- Search modal -->

        <trax-ui-modal-default id="enac-custom-hdv-search" :bus="bus" :title="lang.polaris.form.advanced_search">
            <enac-custom-hdv-crud-search id="enac-custom-hdv" :bus="bus"></enac-custom-hdv-crud-search>
        </trax-ui-modal-default>

        <!-- Toastr -->

        <trax-ui-toastr id="enac-custom-hdv-toastr" :bus="bus" passed-label="1" no-progress="1">
        </trax-ui-toastr>
    
    </div>
</template>

<script>
    export default {
    
        data: function() {
            return {
                lang: lang,
                user: user,
                bus: new Vue()
            }
        },

        computed: {
            card_actions() {
                return this.user.admin || this.user.permissions['hdv_flow.manage']
                    ? [
                        { icon: 'search', event: 'enac-custom-hdv-search-open' },
                        { icon: 'check', event: 'enac-custom-hdv-check-all-open' },
                        { icon: 'close', event: 'enac-custom-hdv-delete-all-open' },
                    ]
                    : [
                        { icon: 'search', event: 'enac-custom-hdv-search-open' },
                    ]
            }
        }
    }
</script>
